var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"innerLoader tnm-registration__loader",attrs:{"role":"status","aria-label":"Wird geladen"}},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"lds-ellipsis tnm-registration__loader-dots",attrs:{"aria-hidden":"true"}},[_c('div'),_c('div'),_c('div'),_c('div')])])])
}]

export { render, staticRenderFns }